<page-data-manager>
  <div class="flash-message-container">
    <flash-message></flash-message>
  </div>

  <div class="row">
    <div class="col-xs-12">
      <div class='page-header'>
        <h2>Editando Depósito</h2>
      </div>
    </div>

    <div class="col-xs-12">
      <form id="deposito_form" name="deposito_form" novalidate ng-submit="save(deposito_form)">
        <div class="row">
          <div class="col-xs-12">
            <div class="panel panel-default no-margin">
              <div class="panel-body">
                <div class="row">
                  <div class="col-xs-12">
                    <div class="form-group">
                      <p><strong>Descrição:</strong> {{::deposito.descricao | capitalize}}</p>
                      <p><strong>Tipo:</strong> {{::deposito.tipo.descricao}}</p>
                      <p><strong>Proprietário:</strong> {{::deposito.proprietario.nome | capitalize}}</p>
                    </div>
                  </div>
                </div>

                <!-- Propriedades -->
                <div class="row" ng-if="!deposito.loading">
                  <div class="col-xs-12">
                    <div class="form-group">
                      <ui-select multiple ng-model="deposito.propriedades" theme="bootstrap" id="propriedades" name="propriedades" ng-change="changeGlebasPropriedade()">
                        <ui-select-match allow-clear="true" placeholder="Propriedade(s)">{{$item.descricao | capitalize}}</ui-select-match>
                        <ui-select-choices repeat="propriedade in allPropriedades | orderBy: 'descricao' | filter: $select.search">
                          <span  class="form-group" ng-bind-html="propriedade.descricao | capitalize | highlight: $select.search"></span>
                        </ui-select-choices>
                      </ui-select>
                    </div>
                  </div>
                </div>

                <!-- glebas -->
                <span ng-show="deposito.loading && !deposito.em_uso">
                  <i class="pull-right fa fa-2x fa-spinner fa-spin"></i>
                </span>
                <div class="row" ng-if="!deposito.em_uso && !deposito.loading && (deposito.propriedades || []).length == 1">
                  <div class="col-xs-12">
                    <div class="form-group">
                      <ui-select multiple ng-model="deposito.glebas" theme="bootstrap" id="glebas" name="glebas">
                        <ui-select-match allow-clear="true" placeholder="Talhões">{{$item.descricao | capitalize}}</ui-select-match>
                        <ui-select-choices repeat="gleba in glebasPropriedade | orderBy: 'descricao' | filter: $select.search ">
                          <span  class="form-group" ng-bind-html="gleba.descricao | capitalize | highlight: $select.search"></span>
                        </ui-select-choices>
                      </ui-select>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xs-12">
                    <div class="form-group">
                      <div class="checkbox">
                        <label>
                          <input type="checkbox" ng-change="clearGlebas()" ng-model="deposito.em_uso"> Em uso
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="row pull-right padding-top-10">
          <div class="col-xs-12 btn-group">
            <button class="btn btn-default btn-sm btn-action" type="button" ng-click="goToShow()">Cancelar</button>

            <button class="btn btn-success btn-sm btn-action" type="submit"
                    ng-disabled="deposito_form.$invalid" >
              Salvar <i class="fa fa-check"></i>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</page-data-manager>
